import React from 'react'

import { TextInput } from '@percent/lemonade'
import styles from './SearchField.module.scss'
import { SearchFieldProps } from './SearchField.types'

export function SearchField({
  value,
  handleChange,
  handleKeyPress,
  placeholder,
  testId = 'search-outlined-input'
}: SearchFieldProps) {
  return (
    <div className={styles.searchFieldContainer}>
      <TextInput
        name="search"
        icon="search"
        data-testid={testId}
        value={value}
        onChange={handleChange}
        onKeyPress={handleKeyPress}
        placeholder={placeholder}
      />
    </div>
  )
}
